export default class {
  constructor() {
    this.isMenuOpen = false;
    this.currentWindowWidth = window.innerWidth;
    this.DOM = {
      headerMenu: document.querySelector('.header__menu'),
      headerBurger: document.querySelector('.header__burger'),
    };

    this.setEvents();
    this.onResize();
  }


  setEvents() {
    let that = this;
    window.addEventListener('resize', this.onResize.bind(this));
    this.DOM.headerBurger.addEventListener('click', event => {
      that.toggleMenu();
    });
  }
  onResize() {
    if (this.currentWindowWidth != window.innerWidth) {
      this.currentWindowWidth = window.innerWidth;
      this.closeMenu();
    }
    this.recalculateMaxHeight();
  }

  toggleMenu() {
    if (this.isMenuOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }
  openMenu() {
    this.DOM.headerMenu.classList.add('open');
    this.isMenuOpen = true;
    document.body.classList.add('hide-overflow');
    this.recalculateMaxHeight();
  }
  closeMenu() {
    this.DOM.headerMenu.classList.remove('open');
    this.isMenuOpen = false;
    document.body.classList.remove('hide-overflow');
  }

  recalculateMaxHeight() {
    document.documentElement.style.setProperty('--header-menu-max-height', `100vh`);;
    setTimeout(() => {
      var viewportOffset = this.DOM.headerMenu.getBoundingClientRect();
      // console.log(window.innerHeight);
      // console.log(viewportOffset.top);
      document.documentElement.style.setProperty('--header-menu-max-height', `${window.innerHeight - viewportOffset.top}px`);
    }, 350);
  }

}
